module.exports = __webpack_public_path__ + "76d07293e7abce892a057c02bc400849.png";